/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { JiraViewAri } from '@atlassian/ari/jira';
import { useActivationId } from '@atlassian/jira-tenant-context-controller/src/components/activation-id/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';

const useNavigationItemId = createRouterSelector((state) => state.match?.params?.navigationItemId);

type CreateViewAriProps = {
	activationId: string;
	cloudId: string;
	viewItemId?: string | null;
	layout?: 'grouped' | 'list' | 'detail';
	projectId?: string | null;
};

export const createViewAri = ({
	activationId,
	cloudId,
	layout,
	projectId,
	viewItemId,
}: CreateViewAriProps): string => {
	const layoutPart = layout ? `/layout/${layout}` : '';

	if (projectId) {
		const viewItemIdPart = viewItemId ? `/${viewItemId}` : '';

		return JiraViewAri.create({
			activationId,
			scopeId: `${projectId}/list${viewItemIdPart}${layoutPart}`,
			scopeType: 'project',
			siteId: cloudId,
		}).toString();
	}

	return JiraViewAri.create({
		activationId,
		scopeId: `issue-navigator${layoutPart}`,
		scopeType: 'global',
		siteId: cloudId,
	}).toString();
};

type Props = {
	layout?: 'grouped' | 'list' | 'detail';
	projectId?: string | null;
};

export const useViewAri = ({ layout, projectId }: Props): string => {
	const activationId = useActivationId();
	const cloudId = useCloudId();
	const viewItemId = useNavigationItemId();

	return createViewAri({
		activationId,
		cloudId,
		layout,
		projectId,
		viewItemId,
	});
};
